import { ReactNode } from 'react';

import { WayToEarnItem } from '@/components/Drugomaniya/WayToEarnList/WayToEarnItem/WayToEarnItem.tsx';

import cn from './styles.module.sass';

interface IWayToEarnListProps {
    wayNumber?: number;
    wayName?: string;
    itemsList: Array<{ number: number; description: string | ReactNode }>;
    gap?: number | string;
}

export const WayToEarnList = ({ wayNumber, wayName, itemsList, gap }: IWayToEarnListProps) => {
    return (
        <div className={cn.container}>
            {wayName && wayNumber && (
                <div className={cn.head}>
                    <p className={cn.wayNumber}>{wayNumber} способ</p>
                    <p className={cn.wayName}>{wayName}</p>
                </div>
            )}
            <div className={cn.list} style={{ gap }}>
                {itemsList.map(item => (
                    <WayToEarnItem
                        key={item.number}
                        number={item.number}
                        description={item.description}
                    />
                ))}
            </div>
        </div>
    );
};
